export interface EnumCommon<T> {
  code: T | string;
  description: string;
  [key: string]: any;
}

export const ALL_ENUM = "ALL";

export const AllItem = { code: ALL_ENUM, description: "Tất cả" };
